import { render, staticRenderFns } from "./Gift.vue?vue&type=template&id=a1464bcc&scoped=true"
import script from "./Gift.vue?vue&type=script&lang=ts"
export * from "./Gift.vue?vue&type=script&lang=ts"
import style0 from "./Gift.vue?vue&type=style&index=0&id=a1464bcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1464bcc",
  null
  
)

export default component.exports